/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetPasswordChangeLink200Response
 */
export interface GetPasswordChangeLink200Response {
    /**
     * 
     */
    link?: string;
}

/**
 * Check if a given object implements the GetPasswordChangeLink200Response interface.
 */
export function instanceOfGetPasswordChangeLink200Response(value: object): value is GetPasswordChangeLink200Response {
    return true;
}

export function GetPasswordChangeLink200ResponseFromJSON(json: any): GetPasswordChangeLink200Response {
    return GetPasswordChangeLink200ResponseFromJSONTyped(json, false);
}

export function GetPasswordChangeLink200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPasswordChangeLink200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'link': json['link'] == null ? undefined : json['link'],
    };
}

export function GetPasswordChangeLink200ResponseToJSON(json: any): GetPasswordChangeLink200Response {
    return GetPasswordChangeLink200ResponseToJSONTyped(json, false);
}

export function GetPasswordChangeLink200ResponseToJSONTyped(value?: GetPasswordChangeLink200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'link': value['link'],
    };
}

